export interface StartMortgageReportFields {
  file: File;
  companyName?: string;
  locationId?: string;
  startDate?: string;
  endDate?: string;
  cost?: string;
  title?: string;
  description?: string;
  aiPersona?: string;
  password?: string;
}

/**
 * Start an AI-generated mortgage report. Uploads the client's CSV export as
 * multipart/form-data; the server enqueues a background job that hands the CSV
 * to Claude (code execution) and produces the HTML dashboard artifact.
 *
 * Uses raw fetch (not fetchAPI) because fetchAPI forces a JSON content-type,
 * which would break the multipart upload — the same pattern as useUploadArtifact.
 */
export const callStartMortgageReport = async (
  fields: StartMortgageReportFields
): Promise<iResponse<{ jobId: string; status: string }>> => {
  const data = new FormData();
  data.append('file', fields.file);

  const append = (key: string, value?: string) => {
    if (value !== undefined && value !== null && value !== '') {
      data.append(key, value);
    }
  };
  append('companyName', fields.companyName);
  append('locationId', fields.locationId);
  append('startDate', fields.startDate);
  append('endDate', fields.endDate);
  append('cost', fields.cost);
  append('title', fields.title);
  append('description', fields.description);
  append('aiPersona', fields.aiPersona);
  append('password', fields.password);

  const token = localStorage.getItem('token');
  // TODO(testing): hardcoded to the local server while we test the mortgage
  // report flow. Revert to `${process.env.REACT_APP_API_BASE}` before going live.
  const apiBase = process.env.REACT_APP_API_BASE;

  const url = `${apiBase}/webhook/generate-mortgage-report`;

  const request: Response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    method: 'POST',
    body: data
  });

  const responseData = await request.json();

  if (request.status >= 400) {
    const response: iResponse<{ jobId: string; status: string }> = {
      code: request.status,
      error: responseData as ResponseErrorObj
    };
    throw response;
  }

  return {
    data: responseData as { jobId: string; status: string },
    code: request.status
  };
};

export default callStartMortgageReport;
